module.exports = __webpack_public_path__ + "static/media/square_blank.7a09780f.png";